export enum EN_STANDARD_BRANCH_NAMESPACE {
  /** 默认 */
  DEFAULT = 'default',
  /** 微服务插件 */
  SERVICE_PLUGIN = 'service.plugin',
  /** ui组件 */
  UI_PLUGIN = 'ui.plugin',
}

export type ISymbol = any;
interface IContainerCommon {
  description: string;
}

export interface IContainerInstance extends IContainerCommon {
  value: any;
  symbol?: ISymbol;
}

export interface IContainerRegisterCommon {
  namespace: EN_STANDARD_BRANCH_NAMESPACE;
  description?: string;
  symbol?: ISymbol;
}

export interface IContainerRegisterInstanceParams extends IContainerRegisterCommon {
  value: any;
}
